import { PrintPdfModel } from "../models/reports-print-pdf-model";
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import { Observable } from "rxjs";
import { PdfReportParams } from "src/app/finance/models/PdfReportParams";
import { RobotoFont } from "src/app/inventory/sales-order/utils/vfs";
import { THEME_COLORS } from "src/app/modules/shared/constants/user-preference.constant";
export class ReportsPrintPdfService {

    public static openOrExportAsPDF(pdfcolumns: any, dataResult: any, organizationName: any, dateFrom: any, dateTo: any, reportName: any, options?: PrintPdfModel.IPrintPdfOptions, doc?: jsPDF, isPrint: boolean = true, themeColor: string = null, cellWidth: number = null): void | Blob {
        options = options ?? new PrintPdfModel.PrintPdfOptions();
        if(!cellWidth && pdfcolumns?.length > 0){
            switch(options.format){
                case 'a1':
                    cellWidth = 812/pdfcolumns?.length; //A1 size in amm
                    break;
                case 'a4':
                    cellWidth = 268/pdfcolumns?.length; //A4 size in mm
                    break;
            }
        }

        let columnStyles: {
            [field: string]: {
                cellWidth?: "auto" | "wrap" | number;
            };
        } = {};
        if (pdfcolumns?.length > 0) {
            pdfcolumns.map(item => {
                columnStyles[item.field] = { cellWidth: cellWidth||"auto" };
            });
        }
        doc = doc ?? new jsPDF(options.orientation, options.unit, options.format);
        doc.addFileToVFS('Roboto-Regular.ttf', RobotoFont);
        doc.addFont('Roboto-Regular.ttf', 'Roboto-Regular', 'normal');

        // doc.setFont('Roboto-Regular');
        doc.setFontSize(options.organizationName.fontSize);
        doc.text(organizationName, options.organizationName.x, options.organizationName.y);

        if(dateFrom && dateTo){
            doc.setFontSize(options.dateFromTo.fontSize);
            let dateFromAsDate = new Date(dateFrom);
            let dateToAsDate = new Date(dateTo);
            let fdate = ((dateFromAsDate.getMonth() > 8) ? (dateFromAsDate.getMonth() + 1) : ('0' + (dateFromAsDate.getMonth() + 1))) + '/' +
                ((dateFromAsDate.getDate() > 9) ? dateFromAsDate.getDate() : ('0' + dateFromAsDate.getDate())) + '/' + dateFromAsDate.getFullYear();
            let tdate = ((dateToAsDate.getMonth() > 8) ? (dateToAsDate.getMonth() + 1) : ('0' + (dateToAsDate.getMonth() + 1))) + '/' +
                ((dateToAsDate.getDate() > 9) ? dateToAsDate.getDate() : ('0' + dateToAsDate.getDate())) + '/' + dateToAsDate.getFullYear();

            !fdate.includes('NaN') && !tdate.includes('NaN') && doc.text(fdate + '  -  ' + tdate, options.dateFromTo.x, options.dateFromTo.y, { align: options.dateFromTo.align });
        }

        doc.setFontSize(options.reportName.fontSize);
        doc.text(reportName, options.reportName.x, options.reportName.y, { align: options.reportName.align });

        autoTable(doc, {
            theme: options.autoTable.theme,
            startY: options.autoTable.startY,
            body: dataResult.length ? dataResult : [],
            columns: dataResult.length ? pdfcolumns : ["No Reports Available."],
            showHead: options.autoTable.showHead,
            headStyles: {
                fillColor: themeColor||THEME_COLORS.blue,
                textColor: '#FFFFFF'
            },
            styles: {
                minCellHeight: options.autoTable.styles.minCellHeight,
                cellWidth: cellWidth||options.autoTable.styles.cellWidth,
                font: options.autoTable.styles.font
            },
            columnStyles: columnStyles ?? null,
        });

        //Print
        if (isPrint) {
            doc.setProperties({ title: reportName + ".pdf" });
            window.open(URL.createObjectURL(doc.output("blob")))
        }
        //export PDF
        else {
            this.saveAsPdfFile(doc, reportName);
        }
    }

    private static saveAsPdfFile(buffer: any, fileName: string): void {
        buffer.save(fileName + '.pdf');
    }

    public static getPdfReportForEmail(params: PdfReportParams): Observable<jsPDF> {
        return new Observable((observer) => {
            try {
                const {
                    pdfcolumns,
                    dataResult,
                    organizationName,
                    dateFrom,
                    dateTo,
                    reportName,
                    options = new PrintPdfModel.PrintPdfOptions(),
                    themeColor = null,
                    cellWidth = null
                } = params;
    
                let adjustedCellWidth = cellWidth;
                if (!adjustedCellWidth && pdfcolumns?.length > 0) {
                    switch (options.format) {
                        case 'a1':
                            adjustedCellWidth = 812 / pdfcolumns?.length;
                            break;
                        case 'a4':
                            adjustedCellWidth = 268 / pdfcolumns?.length;
                            break;
                    }
                }
    
                const columnStyles: { [field: string]: { cellWidth?: "auto" | "wrap" | number } } = {};
                pdfcolumns?.forEach(item => {
                    columnStyles[item.field] = { cellWidth: adjustedCellWidth || "auto" };
                });
    
                const pdf = new jsPDF(options.orientation, options.unit, options.format);
                pdf.addFileToVFS("Roboto-Regular.ttf", RobotoFont);
                pdf.addFont("Roboto-Regular.ttf", "Roboto-Regular", "normal");
                pdf.setFont("Roboto-Regular");
    
                // Header Information
                pdf.setFontSize(options.organizationName.fontSize);
                pdf.text(organizationName, options.organizationName.x, options.organizationName.y);
    
                if (dateFrom && dateTo) {
                    pdf.setFontSize(options.dateFromTo.fontSize);
                    const formattedDateFrom = new Date(dateFrom).toLocaleDateString();
                    const formattedDateTo = new Date(dateTo).toLocaleDateString();
    
                    pdf.text(`${formattedDateFrom} - ${formattedDateTo}`, options.dateFromTo.x, options.dateFromTo.y, {
                        align: options.dateFromTo.align,
                    });
                }
    
                pdf.setFontSize(options.reportName.fontSize);
                pdf.text(reportName, options.reportName.x, options.reportName.y, { align: options.reportName.align });
    
                // Table Content
                autoTable(pdf, {
                    theme: options.autoTable.theme,
                    startY: options.autoTable.startY,
                    body: dataResult.length ? dataResult : [["No Reports Available."]],
                    columns: dataResult.length ? pdfcolumns : ["No Reports Available."],
                    showHead: options.autoTable.showHead,
                    headStyles: {
                        fillColor: themeColor || THEME_COLORS.blue,
                        textColor: '#FFFFFF'
                    },
                    styles: {
                        minCellHeight: options.autoTable.styles.minCellHeight,
                        cellWidth: adjustedCellWidth || options.autoTable.styles.cellWidth,
                        font: options.autoTable.styles.font
                    },
                    columnStyles: columnStyles ?? null,
                });
    
                observer.next(pdf);
                observer.complete();
            } catch (error) {
                observer.error(error);
            }
        });
    }    
}
